export default __webpack_public_path__ + "static/media/June2013.ce63d376.png";